var WorkerClient = require('./worker-client');

module.exports = function(src) {
	var _t = this;
	var poolSize = navigator.hardwareConcurrency || 4;
	var pool = [];
	var jobQueue = [];

	// Googlebot apparently has like a million cores. And it apparently performs
	// ZERO caching of the scripts. But it's also apparently is very slow ...
	// ... so, we're attempting to ensure googlebot isn't hung up fetching 16 or
	// 32 or 128 worker scripts very slowly instead of rendering the page.
	if (navigator.userAgent.match(/Googlebot/)) {
		poolSize = 2;
	}
	
	for (var i = 0; i < poolSize; i++) {
		pool.push(new WorkerClient(src));
	}

	this.run = function(job) {
		jobQueue.push(job);
	};

	this.getWorker = function() {
		var availableWorkers = pool.filter(function(w) { return w.isAvailable(); });
		if (availableWorkers.length == 0) return;
		return availableWorkers.shift();
	};

	this.assignWork = function() {
		var worker = this.getWorker();
		var job = jobQueue.shift();
		if (job && worker) {
			worker.run(job);
		}
	};

	setInterval(function() { _t.assignWork(); }, 50);
};
